import { AutoComplete, Input, Tooltip, Breadcrumb } from "antd";
import { t } from "i18next";
import {
  AscRed,
  DescGrey,
  DeleteIcon,
  DetailIcon,
  EditIcon,
  PlusIcon,
  SearchIcon,
  SupportIcon,
  NotSupportIcon,
} from "../../../../asset";
import style from "./deliveryTypePage.module.css";
import CustomTable from "../../../../component/table/CustomTable";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import DeleteConfirmationModal from "../../../../component/modal/DeleteConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import { useState } from "react";
import SelectSearch from "../../../../component/input/SelectSearch";
import { useDeliveryType } from "./DeliveryTypePage.hooks";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import { permissionButton } from "../../../../util/Util";
import { useSelector } from "react-redux";

export default function DeliveryTypeList() {
  const {
    deleteConfirmationModalOpen,
    setDeleteConfirmationModalOpen,
    successModalOpen,
    setSuccessModalOpen,
    toAddDeliveryType,
    toEditDeliveryType,
    toDetailDeliveryType,
    deleteConfirmation,
    doGetDeliveryType,
    list,
    listDropdown,
    totalData,
    handlePagination,
    selectDepotId,
    sorting,
    doSort,
    toListDeliveryType,
    selectedDeliveryType,
    selectedDeliveryTypeId,
    selectedUpdatedAt,
    doDeleteDeliveryType,
    options,
    onSelect,
    onSearch,
    searchKeyword,
    statePageSize,
    setStatePageSize,
    handleChangeLimit,
    selectedDepotId,
    currentPage,
    onScroll,
    onSearchDDS,
    depotKeyword,
    dropdownListLoading,
    isSupportMitraGro
  } = useDeliveryType();

  const { permission } = useSelector((state) => state.auth);
  const DeliveryTypeListColumn = [
    {
      title: (
        <span className="font-medium text-lg text-[#222222]">
          {t("DELIVERY_TYPE_LIST:DELIVERY_TYPE_ID_FIELD")}
        </span>
      ),
      dataIndex: "deliveryTypeId",
      key: "deliveryTypeId",
      render: (deliveryTypeId) => <span>{deliveryTypeId}</span>,
    },
    {
      title: (
        <div className="flex w-auto">
          <span className="font-medium text-lg text-[#222222]">
            {t("DELIVERY_TYPE_LIST:DELIVERY_TYPE_FIELD")}
          </span>
          <div style={{ marginLeft: "10px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "delivery_type asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={
                    sorting === "delivery_type asc"
                      ? "w-[10px] h-[10px] cursor-pointer"
                      : "rotate-180 w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => doSort("delivery_type asc")}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "delivery_type desc" ? AscRed : DescGrey}
                  alt="desc"
                  className={
                    sorting === "delivery_type desc"
                      ? "w-[10px] h-[10px] cursor-pointer rotate-180 "
                      : "w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => doSort("delivery_type desc")}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "deliveryType",
      key: "deliveryType",
      render: (deliveryType) => <span>{deliveryType}</span>,
    },
    // {
    //     title: (
    //         <div className="flex w-auto">
    //             <span className="font-medium text-lg text-[#222222]">
    //                 {t("DELIVERY_TYPE_LIST:DESCRIPTION_FIELD")}
    //             </span>
    //         </div>
    //     ),
    //     dataIndex: 'description',
    //     key: 'description',
    //     render: (description) => <span>{description}</span>,
    // },
    {
      title: (
        <div className="flex w-auto">
          <span className="font-medium text-lg text-[#222222]">
            {t("Cost/Kg")}
          </span>
        </div>
      ),
      dataIndex: "costkg",
      key: "costkg",
      render: (costkg) => <span>{costkg}</span>,
    },
    {
      title: (
        <div className="flex w-auto">
          <span className="font-medium text-lg text-[#222222]">
            {t("Cost/m")}<sup>3</sup>
          </span>
        </div>
      ),
      dataIndex: "costm",
      key: "costm",
      render: (costm) => <span>{costm}</span>,
    },
    {
      title: (
        <div className="flex w-auto">
          <span className="font-medium text-lg text-[#222222]">
            {t("Cost/Km")}
          </span>
        </div>
      ),
      dataIndex: "costkm",
      key: "costkm",
      render: (costkm) => <span>{costkm}</span>,
    },
    {
      title: (
        <div className="flex w-auto">
          <span className="font-medium text-lg text-[#222222]">
            {t("Cost/Hours")}
          </span>
        </div>
      ),
      dataIndex: "costhours",
      key: "costhours",
      render: (costhours) => <span>{costhours}</span>,
    },
    {
      title: (
        <div className="flex w-auto">
          <span className="font-medium text-lg text-[#222222]">
            {t("Start Trip")}
          </span>
        </div>
      ),
      dataIndex: "starttrip",
      key: "starttrip",
      render: (starttrip) => <span>{starttrip}</span>,
    },
    {
      title: (
        <div className="flex w-auto">
          <span className="font-medium text-lg text-[#222222]">
            {t("Support MitraGro")}
          </span>
        </div>
      ),
      dataIndex: "supportmitragro",
      key: "supportmitragro",
      render: (supportmitragro) => <span>{supportmitragro}</span>,
    },
    {
      title: (
        <span className="font-medium text-lg text-[#222222]">
          {t("DELIVERY_TYPE_LIST:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => <span>{action}</span>,
    },
  ];

  const dataSource = list?.map((item) => ({
    deliveryTypeId: (
      <span className="font-roboto text-lg text-[#222222]">{item.id}</span>
    ),
    deliveryType: (
      <span className="font-roboto text-lg text-[#222222]">
        {item.delivery_type}
      </span>
    ),
    costkg: (
      <span className="font-roboto text-lg text-[#222222] flex justify-between">
        <div>Rp.</div>
        <div>{item.price_weight}</div>
      </span>
    ),
    costm: (
      <span className="font-roboto text-lg text-[#222222] flex justify-between">
        <div>Rp.</div>
        <div>{item.price_volume}</div>
      </span>
    ),
    costkm: (
      <span className="font-roboto text-lg text-[#222222] flex justify-between">
        <div>Rp.</div>
        <div>{item.price_distance}</div>
      </span>
    ),
    costhours: (
      <span className="font-roboto text-lg text-[#222222] flex justify-between">
        <div>Rp.</div>
        <div>{item.price_time}</div>
      </span>
    ),
    starttrip: (
      <span className="font-roboto text-lg text-[#222222]">
        {item.automatic_start_trip
          ? "Automatic - " + item.start_trip_time
          : "Manual"}
      </span>
    ),
    supportmitragro: (
        <span className="font-roboto text-lg text-[#222222]">
          {item.support_mitra_gro ? <img src={SupportIcon} alt="support"/> : <img src={NotSupportIcon} alt="notsupport"/>}
        </span>
      ),
    action: (
      <div className="flex gap-[26px]">
        <Tooltip
          className={
            permissionButton(permission, "update", "deliverytype", "setup")
              ? ""
              : "hidden"
          }
          title={t("USER:EDIT_TOOLTIP")}
          color="#CF0000"
        >
          <button>
            <img src={EditIcon} onClick={() => toEditDeliveryType(item)} />
          </button>
        </Tooltip>
        <Tooltip
          className={
            permissionButton(permission, "delete", "deliverytype", "setup")
              ? ""
              : "hidden"
          }
          title={t("USER:DELETE_TOOLTIP")}
          color="#CF0000"
        >
          <button>
            <img
              src={DeleteIcon}
              onClick={() =>
                deleteConfirmation(item.id, item.updated_at, item.delivery_type)
              }
            />
          </button>
        </Tooltip>
        <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
          <button>
            <img
              src={DetailIcon}
              onClick={() => toDetailDeliveryType(item.id)}
            />
          </button>
        </Tooltip>
      </div>
    ),
  }));

  const selectSearchData = listDropdown.map((item) => ({
    value: item.depot_id,
    label: item.depot_name,
  }));

  return (
    <div className="p-[24px] flex flex-col gap-[24px]">
      <DeleteConfirmationModal
        isOpen={deleteConfirmationModalOpen}
        onOk={() => setDeleteConfirmationModalOpen(false)}
        onCancel={() => doDeleteDeliveryType()}
        closable={false}
        width={440}
        className={style.modalContainer}
        okText="Cancel"
        cancelText="Yes, Delete"
        title="Delete Data?"
        description={
          <p>
            Are you Sure want to delete{" "}
            <strong>Delivery Type ID {selectedDeliveryTypeId}?</strong>
          </p>
        }
      />

      <SuccessModal
        isOpen={successModalOpen}
        onOk={() => setSuccessModalOpen(false)}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been deleted"
      />

      <Breadcumbs
        jmlLevel={3}
        menuLevel1={`Master`}
        menuLevel2={`Fleet`}
        menuLevel3={`Delivery Type`}
      />

      <h1 className="font-sans-bold text-2xl" id="title">
        {t("DELIVERY_TYPE_LIST:TITLE")}
      </h1>

      <div
        className={style.headerContainer + " flex justify-between items-center"}
      >
        <div className="flex gap-[16px]">
          <AutoComplete
            options={options}
            onSelect={onSelect}
            value={searchKeyword}
            allowClear={true}
            onClear={() =>
              doGetDeliveryType(selectedDepotId, 1, 10, sorting, true)
            }
          >
            <Input
              placeholder={t("Search Delivery Type")}
              height={47}
              value={searchKeyword}
              onChange={(event) => onSearch(event)}
              suffix={() => (!searchKeyword ? <img src={SearchIcon} /> : "")}
              style={{ fontSize: "20px" }}
            />
          </AutoComplete>

          {/* <SelectSearch style={style} onSelect={(value) => selectDepotId(value, 1, 10)} data={selectSearchData} defaultValue={selectSearchData ? selectSearchData[0] : ''} /> */}

          {/* {
                        listDropdown?.length !== 0 ?

                            <SelectSearch onScroll={(event) => onScroll(event, 'depotList')} keyword={depotKeyword} onChange={(value) => onSearchDDS(value, 'depotList')} onSelect={(value) => selectDepotId(value, 1, 10)} width={292} options={listDropdown} loading={dropdownListLoading} defaultValue={listDropdown[0].value} />

                            :

                            null
                    } */}
        </div>

        <PrimaryButton
          actions="insert"
          menu="deliverytype"
          parent="setup"
          text={t("DELIVERY_TYPE_LIST:ADD_DELIVERY_TYPE_BUTTON")}
          prefixIcon={<img src={PlusIcon} />}
          action={() => toAddDeliveryType()}
        />
      </div>

      <div className={style.tableContainer}>
        <CustomTable
          currentPage={currentPage}
          columns={DeliveryTypeListColumn}
          data={dataSource}
          pageLimit={statePageSize}
          onChange={(page, pageSize) =>
            handleChangeLimit(page, pageSize, selectedDepotId)
          }
          total={totalData}
          showPagination
        />
      </div>
    </div>
  );
}
